import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiDependentMutationRequest,
  PostApiDependentMutationResponse,
  PostApiDependent401,
  PostApiDependent403,
} from "../../../types/PostApiDependent";

export function getPostApiDependentUrl() {
  return `/api/Dependent` as const;
}

/**
 * {@link /api/Dependent}
 */
export async function postApiDependent(
  data?: PostApiDependentMutationRequest,
  config: Partial<RequestConfig<PostApiDependentMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiDependentMutationResponse,
    ResponseErrorConfig<PostApiDependent401 | PostApiDependent403>,
    PostApiDependentMutationRequest
  >({
    method: "POST",
    url: getPostApiDependentUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
